import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import "../create-form.css";
import BuildConfigForm from './build-config-form';

interface StateProps {
  metadataReducer: any;
}

// declare prop check
type Props = {
  dispatch: Dispatch<any>;
} & StateProps &
  RouteComponentProps<any>;

class CreateBuildConfig extends Component<Props> {
  render() {
    return (
      <div className="create-form">
        <BuildConfigForm history={this.props.history} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    metadataReducer: state.metadataReducer,
  };
};

export default withRouter(connect<StateProps>(mapStateToProps)(CreateBuildConfig));
